export type RequiredAnswerRow = {
  id: string;
  questionId: string;
  answerId: string;
};

let nextRowId = 0;

/** A blank row with an id of its own, so rows keep their identity when others are removed. */
export const newAnswerRow = (): RequiredAnswerRow => {
  nextRowId += 1;
  return {id: `answer-row-${nextRowId}`, questionId: '', answerId: ''};
};

/**
 * Whether a question is listed more than once. Every row must match, so two
 * rows for one question can only be met by a player who gave both answers,
 * and nobody can.
 */
export const hasDuplicateQuestionIds = (rows: RequiredAnswerRow[]) => {
  const questionIds = rows
    .map(({questionId}) => questionId.trim())
    .filter(Boolean);
  return new Set(questionIds).size !== questionIds.length;
};

/** User ids from the entrants CSV, which has a header row and then one quoted id per line. */
export const parseEntrantUserIds = (csv: string) =>
  csv
    .split('\n')
    .slice(1)
    .map(line => /^"([^"]*)"/.exec(line)?.[1])
    .filter((userId): userId is string => !!userId);
